<form #customForm="ngForm">
  <!-- Record Type -->
  <div class="mb-3">
    <label class="form-label">Record Type <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="customFormData.selectedRecord" (ngModelChange)="onRecordChange()"
            name="selectedRecord">
      <option value="" disabled selected>Select record type</option>
      <option value="annual">Annual School Profile</option>
      <option value="project">Project</option>
      <option value="partner">Partner</option>
    </select>
  </div>

  <div class="d-flex flex-wrap gap-2 justify-content-center" *ngIf="customFormData.selectedRecord">
    <!-- Annual -->
    <ng-container *ngIf="customFormData.selectedRecord === 'annual'">
      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('years')">
        Year
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('school')">
        School
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('cluster')">
        Cluster
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('goals')">
        Goals
      </button>

      <button type="button" class="btn btn-outline-primary reset-btn" (click)="reset()">
        RESET
      </button>
    </ng-container>

    <!-- project -->
    <ng-container *ngIf="customFormData.selectedRecord === 'project'">
      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('categories')">
        Categories
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('years')">
        Year
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('school')">
        School
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('cluster')">
        Cluster
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('partnerName')">
        Partner
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('grant')">
        Grant
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('grades')">
        Grade
      </button>

      <button type="button" class="btn btn-outline-primary reset-btn" (click)="reset()">
        RESET
      </button>
    </ng-container>

    <!-- partner -->
    <ng-container *ngIf="customFormData.selectedRecord === 'partner'">
      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('partnerName')">
        Partner Name
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('contactName')">
        Contact Name
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('projectAreas')">
        Project Area
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('services')">
        Services
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('status')">
        Status
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('fundingSupport')">
        Funding Support
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('feeOrFree')">
        Fee/Free
      </button>

      <button type="button" class="btn btn-outline-primary"
              (click)="toggleFilter('feeService')">
        Fee Service
      </button>

      <button type="button" class="btn btn-outline-primary reset-btn" (click)="reset()">
        RESET
      </button>
    </ng-container>
  </div>

  <div *ngIf="activeFilters.years" class="mb-3">
    <label>Year(s)</label>
    <div class="row">
      <div class="col-6" *ngFor="let y of getSchoolYears()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="y"
                 [checked]="isSelectedYear(y)"
                 (change)="toggleYear(y, $event)">
          <label class="form-check-label" [for]="y">{{ y }}</label>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeFilters.school && customFormData.selectedRecord === 'annual'" class="mb-3">
    <label>School</label>
    <select class="form-select"
            [(ngModel)]="customAnnualData.school"
            name="school">
      <option value="" disabled selected>Select school</option>
      <option *ngFor="let s of getFilteredSchools()" [value]="s">{{ s }}</option>
    </select>
  </div>

  <div *ngIf="activeFilters.school && customFormData.selectedRecord === 'project'" class="mb-3">
    <label>School</label>
    <select class="form-select"
            [(ngModel)]="customProjectData.school"
            name="school">
      <option value="" disabled selected>Select school</option>
      <option *ngFor="let s of getFilteredSchools()" [value]="s">{{ s }}</option>
    </select>
  </div>

  <div *ngIf="activeFilters.cluster && customFormData.selectedRecord === 'annual'" class="mb-3">
    <label>Cluster</label>
    <select class="form-select" [(ngModel)]="customAnnualData.cluster" name="annualCluster">
      <option value="" disabled selected>Select cluster</option>
      <option *ngFor="let c of getClusters()" [value]="c">{{ c }}</option>
    </select>
  </div>

  <div *ngIf="activeFilters.cluster && customFormData.selectedRecord === 'project'" class="mb-3">
    <label>Cluster</label>
    <select class="form-select" [(ngModel)]="customProjectData.cluster" name="projectCluster">
      <option value="" disabled selected>Select cluster</option>
      <option *ngFor="let c of getClusters()" [value]="c">{{ c }}</option>
    </select>
  </div>

  <div *ngIf="activeFilters.goals" class="mb-3">
    <label>Goals</label>
    <div class="row">
      <div class="col-6" *ngFor="let g of getGoals()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="g"
                 [checked]="isGoalSelected(g)"
                 (change)="toggleGoal(g, $event)">
          <label class="form-check-label" [for]="g">{{ g }}</label>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeFilters.categories" class="mb-3">
    <label>Categories</label>
    <div class="row">
      <div class="col-6" *ngFor="let c of getProjectCategoriesForForm()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="c"
                 [checked]="isCategorySelected(c)"
                 (change)="toggleCategory(c, $event)">
          <label class="form-check-label" [for]="c">
            {{ categoryFriendlyNames[c] || c }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3" *ngIf="activeFilters.grant">
    <label>Grant</label>
    <select class="form-select" [(ngModel)]="customProjectData.grant" name="grant">
      <option value="" disabled selected>Select</option>
      <option value="yes">Yes</option>
      <option value="no">No</option>
    </select>
  </div>

  <div class="mb-3" *ngIf="activeFilters.grades">
    <label>Grades</label>
    <div class="row">
      <div class="col-6" *ngFor="let g of getGrades()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="g"
                 [checked]="isGradeSelected(g)"
                 (change)="toggleGrade(g, $event)">
          <label class="form-check-label" [for]="g">{{ g }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3" *ngIf="customFormData.selectedRecord === 'project' && activeFilters.partnerName">
    <label>Partner Name Contains</label>
    <input class="form-control"
           [(ngModel)]="customProjectData.partnerContains"
           name="partnerContains">
  </div>

  <div class="mb-3" *ngIf="customFormData.selectedRecord === 'partner' && activeFilters.partnerName">
    <label>Partner Name Contains</label>
    <input class="form-control"
           [(ngModel)]="customPartnerData.partnerNameContains"
           name="partnerNameContains">
  </div>

  <div class="mb-3" *ngIf="activeFilters.contactName">
    <label>Contact Name Contains</label>
    <input class="form-control"
           [(ngModel)]="customPartnerData.contactNameContains"
           name="contactNameContains">
  </div>

  <div class="mb-3" *ngIf="activeFilters.projectAreas">
    <label>Project Areas</label>
    <div class="row">
      <div class="col-6" *ngFor="let p of getProjectAreas()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="p"
                 [checked]="isProjectAreaSelected(p)"
                 (change)="toggleProjectArea(p, $event)">
          <label class="form-check-label" [for]="p">{{ p }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3" *ngIf="activeFilters.services">
    <label>Services Offered</label>
    <div class="row">
      <div class="col-6" *ngFor="let s of getServicesOffered()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="s"
                 [checked]="isServiceSelected(s)"
                 (change)="toggleService(s, $event)">
          <label class="form-check-label" [for]="s">{{ s }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3" *ngIf="activeFilters.status">
    <label>Partner Status</label>
    <select class="form-select" [(ngModel)]="customPartnerData.partnerStatus" name="partnerStatus">
      <option value="" disabled selected>Select status</option>
      <option value="active">Active</option>
      <option value="inactive">Inactive</option>
    </select>
  </div>

  <div class="mb-3" *ngIf="activeFilters.fundingSupport">
    <label>Funding Support</label>
    <div class="row">
      <div class="col-6" *ngFor="let s of getFundingSupport()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="s"
                 [checked]="isFundingSelected(s)"
                 (change)="toggleFunding(s, $event)">
          <label class="form-check-label" [for]="s">{{ s }}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3" *ngIf="activeFilters.feeOrFree">
    <label>Are services Free or Fee based?</label>
    <select class="form-select" [(ngModel)]="customPartnerData.feeOrFree" name="feeOrFree">
      <option value="" disabled selected>Select free/fee</option>
      <option value="free">Free</option>
      <option value="fee">Fee</option>
    </select>
  </div>

  <div class="mb-3" *ngIf="activeFilters.feeService">
    <label>Fee Services</label>
    <div class="row">
      <div class="col-6" *ngFor="let s of getFeeServices()">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 [id]="s"
                 [checked]="isFeeSelected(s)"
                 (change)="toggleFeeService(s, $event)">
          <label class="form-check-label" [for]="s">{{ s }}</label>
        </div>
      </div>
    </div>
  </div>

  <button type="button" class="btn generate-btn mb-3 mt-2" *ngIf="customFormData.selectedRecord"
          (click)="generateCustomExcel()">
    Generate Excel
  </button>
</form>
